import { PlantIdRequest, UnitcodeDto } from '@gtpl/shared-models/masters';
import { AssignForCookingResponse, CookingDto, CookingInventoryResponse, GetCookingInfoResponse } from '@gtpl/shared-models/production-management';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { ProductionInventoryData } from '../dto/production-inventory.dto';
import { UnitRequest } from '../dto/unit.id.request';
import { CookingService } from './cooking.service';

@ApiTags('Cooking')
@Controller('cooking')
export class CookingController {
    constructor(private service: CookingService, private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }

    @Post('getCookingInprogressLogs')
    async getCookingInprogressLogs(@Body() req: UnitRequest): Promise<GetCookingInfoResponse> {
        try {
            return this.service.getCookingInprogressLogs(req.unitId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(GetCookingInfoResponse, error);
        }
    }

    @Post('getCookingInventory')
    async getCookingInventory(@Body() req: UnitRequest): Promise<CookingInventoryResponse> {
        try {
            return this.service.getCookingInventory(req.unitId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CookingInventoryResponse, error);
        }
    }

    @Post('getReadyForCookingInventory')
    async getReadyForCookingInventory(@Body() req: UnitRequest): Promise<CookingInventoryResponse> {
        try {
            return this.service.getReadyForCookingInventory(req.unitId);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(CookingInventoryResponse, error);
        }
    }

    @Post('/assignToCooking')
    async assignToCooking(@Body() inventoryInfo: ProductionInventoryData): Promise<AssignForCookingResponse> {
        try {
            return await this.service.assignToCooking(inventoryInfo);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssignForCookingResponse, error);
        }
    }

    @Post('/jobCompletedStatus')
    async jobCompletedStatus(@Body() cooking: CookingDto): Promise<AssignForCookingResponse> {
        try {
            return await this.service.jobCompletedStatus(cooking);
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AssignForCookingResponse, error);
        }
    }

}
